module.exports = __webpack_public_path__ + "static/assets/scan-red-new.svg";